/*eslint-disable*/
import React from 'react';
import * as yup from 'yup';
import { Form as FormUi, Button, Label, Modal, Table, Icon } from 'semantic-ui-react';
import { Field as Fieldmik, FieldArray, Formik, ErrorMessage } from 'formik';

import { MyInput } from '../formikInput/input';
import PSLineItemDropdown from '../dropdowns/psLineItemDropdown';

const BillApprovalModal = ({ getApproveBillData, selectedRows, approveBillsSelected, handleCloseBillApproval, ...props }) => {

    let billDetails = [];

    selectedRows && selectedRows.map((o, i) => {
        let temp = {}
        temp.billReferenceNo = o.refNo
        temp.vendorCode = o.vendorCode
        temp.approvalStatus = "Approved"
        temp.penaltyList = [{
            psCode: '',
            penaltyAmt: '',
        }]
        billDetails[i] = temp
    });

    const initialValues = {
        billDetails: billDetails
    };

    const onSubmit = (values) => {


        let approvalStatusData = []

        values.billDetails.map((o, i) => {

            let temp = {}
            temp.billReferenceNo = o.billReferenceNo
            temp.approvalStatus = o.approvalStatus
            temp.vendorCode = o.vendorCode

            let psLine = []
            o.penaltyList.map((penalty, penaltyIndex) => {

                if (penalty.psCode.length > 0 && penalty.penaltyAmt > 0) {
                    let tempPenalty = {}
                    temp.psCode = penalty.psCode
                    temp.penaltyAmt = penalty.penaltyAmt
                    psLine[penaltyIndex] = tempPenalty
                }
            })

            temp.penaltyList = psLine

            approvalStatusData[i] = temp
        })
        approveBillsSelected(approvalStatusData)
    };

    return (
        <>
            <Formik
                initialValues={initialValues}
                validationSchema={yup.object({
                    billDetails: yup.array().of(
                        yup.object().shape({
                            penaltyList: yup.array().of(
                                yup.object().shape({
                                    psCode: yup.mixed(),
                                    penaltyAmt: yup.number().positive().when(['psCode'], (psCode, schema) => {
                                        return psCode && psCode.length > 0 ? schema.required("Penalty Amount is Required").min(1, "Penalty Amount should be more than 0") : schema.min(1)
                                    })
                                })
                            )
                        })
                    )

                })}
                onSubmit={onSubmit}
            >
                {({ touched, errors, handleSubmit, isSubmitting }) => (
                    <>
                        <FieldArray
                            name={'billDetails'}
                        >
                            {({ push, remove, form }) => {
                                const { inititalValues, values, setFieldValue } = form
                                const { billDetails } = values

                                return (
                                    <>
                                        <Modal.Content>
                                            <Table verticalAlign stackable>
                                                <Table.Header>
                                                    <Table.Row>
                                                        <Table.HeaderCell><label className="labelName p-bold-600">Bill Number</label></Table.HeaderCell>
                                                        <Table.Row>
                                                            <Table.HeaderCell width={8}><label className="labelName p-bold-600">Expense Particular</label></Table.HeaderCell>
                                                            <Table.HeaderCell colSpan="8" ><label className="labelName p-bold-600" style={{ marginLeft: '70px' }}>Penalty Amount</label></Table.HeaderCell>
                                                        </Table.Row>

                                                    </Table.Row>
                                                </Table.Header>
                                                <Table.Body>
                                                    {billDetails.map((bill, billIndex) => {
                                                        return (
                                                            <>
                                                                <Table.Row>
                                                                    <Table.Cell>
                                                                        <FormUi.Field>
                                                                            <Fieldmik name="billReferenceNo" component={MyInput} placeholder="Code" value={bill.billReferenceNo} />
                                                                            {touched.billReferenceNo && errors.billReferenceNo ? <Label size="mini" prompt pointing>{errors.billReferenceNo}</Label> : ''}
                                                                        </FormUi.Field>
                                                                    </Table.Cell>

                                                                    <FieldArray
                                                                        name={`billDetails[${billIndex}].penaltyList`}
                                                                    >
                                                                        {({ push, remove, form }) => {

                                                                            const { initialValues, values, setFieldValue } = form
                                                                            const { penaltyList } = values.billDetails[billIndex]

                                                                            return (
                                                                                <>
                                                                                    {penaltyList.map((penalty, penaltyIndex) => (
                                                                                        <>
                                                                                            <Table.Row>
                                                                                                <Table.Cell width={4}>
                                                                                                    <FormUi.Field>
                                                                                                        <Fieldmik name={`billDetails[${billIndex}].penaltyList[${penaltyIndex}].psCode`} component={PSLineItemDropdown} placeholder="Enter Expense Code" />
                                                                                                        <ErrorMessage name={`billDetails[${billIndex}].penaltyList[${penaltyIndex}].psCode`}>{msg => <Label size="mini" prompt pointing>{msg}</Label>}</ErrorMessage>
                                                                                                    </FormUi.Field>
                                                                                                </Table.Cell>

                                                                                                <Table.Cell width={2}>
                                                                                                    <FormUi.Field>
                                                                                                        <Fieldmik name={`billDetails[${billIndex}].penaltyList[${penaltyIndex}].penaltyAmt`} style={{ width: '160px' }} component={MyInput} placeholder="Enter Amount" />
                                                                                                        <ErrorMessage name={`billDetails[${billIndex}].penaltyList[${penaltyIndex}].penaltyAmt`}>{msg => <Label size="mini" prompt pointing>{msg}</Label>}</ErrorMessage>
                                                                                                    </FormUi.Field>
                                                                                                </Table.Cell>

                                                                                                <Table.Cell width={2}>
                                                                                                    {penaltyIndex > 0 ?
                                                                                                        <Button onClick={() => remove(penaltyIndex)} type="button" basic size="mini" icon>
                                                                                                            <Icon className="overhere" color="red" name="trash" />
                                                                                                        </Button>
                                                                                                        :
                                                                                                        ''}
                                                                                                </Table.Cell>
                                                                                            </Table.Row>

                                                                                        </>
                                                                                    ))}

                                                                                    <Table.Cell>
                                                                                        <Button type="button" onClick={() => push({ psCode: '', penaltyAmt: '' })} size="mini" basic color="blue">
                                                                                            + Add
                                                                                        </Button>
                                                                                    </Table.Cell>

                                                                                </>
                                                                            )
                                                                        }}
                                                                    </FieldArray>
                                                                </Table.Row>
                                                            </>
                                                        )
                                                    })}

                                                </Table.Body>

                                            </Table>
                                        </Modal.Content>
                                    </>
                                )
                            }}
                        </FieldArray>
                        <Modal.Actions>
                            <Button onClick={handleCloseBillApproval} size="mini">Cancel</Button>
                            <Button disabled={isSubmitting} type="submit" onClick={handleSubmit} size="mini" primary>Submit</Button>
                        </Modal.Actions>
                    </>
                )}
            </Formik>
        </>
    )
}


export default BillApprovalModal
